import { SStyled } from './theme'
import SBox from '../components/opinionless/SBox'
import SText from '../components/opinionless/SText'

export const Table = SStyled(SBox)`
    color: ${(p) => p.theme.colors.gray400};
    border-collapse: collapse;
    margin-top: ${(p) => p.theme.space[4]}px;
    width: 100%;

    thead tr th {
        background-color: ${(p) => p.theme.colors.gray100};
    }
    

    thead tr th:first-of-type {
        border-radius: 10px 0 0 10px;
    }

    thead tr th:last-of-type {
        border-radius: 0 10px 10px 0;
    }

    thead tr th {
        text-align: left;
        font-weight: normal;
        padding-top: ${(p) => `${p.theme.space[3]}px`} !important;
        padding-bottom: ${(p) => `${p.theme.space[3]}px`} !important;
        padding-left: ${(p) => `${p.theme.space[4]}px`} !important;
        padding-right: ${(p) => `${p.theme.space[4]}px`} !important;
    }

    tr td {
        padding-left: ${(p) => `${p.theme.space[4]}px`} !important;
        padding-right: ${(p) => `${p.theme.space[4]}px`} !important;
        padding-top: ${(p) => `${p.theme.space[5]}px`} !important;
        padding-bottom: ${(p) => `${p.theme.space[2]}px`} !important;
        
    }

    tbody tr {
        border-bottom: ${(p) => `0.5px solid ${p.theme.colors.gray100}`};
    }

    tbody tr:last-child {
        border-bottom: none;
    }

    tbody tr td {
        padding: ${(p) => `${p.theme.space[4]}px 0`};
    }
`

export const TableHeaderText = SStyled(SText)`
    font-size: ${(p) => p.theme.fontSizes[3]}px;
`
